module.exports = __webpack_public_path__ + "img/04_kii_03.16d006fb.jpg";